import React from 'react';
import { useState } from 'react'
import { useCarrito } from './Cart';
import styles from './stylesComponent/CartDropdown.module.css';
import { Link } from 'react-router-dom';

export default function CartDropdown(){
    const { carrito, removeItem, cantidadTotal, clearCarrito } = useCarrito();
    const [usuario, setUsuario] = useState(() => {
            const usuarioAlmacenado = localStorage.getItem("userLogueado");
            return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    return (
        <div className={styles.CartDropdown} style={{ padding: carrito.length === 0 ? 0 : '16px' }}>
            {carrito.length === 0 ? (
                <p className={styles.vacio}>Su carrito está vacío</p>
            ) : (
                <>
                <ul className={styles.listaItems}>
                    {carrito.map((p) => (
                        <li key={p._id} className={styles.item}>
                            <div className={styles.itemInfo}>
                                <img
                                    src={`data:image/png;base64,${p.ImagenPortada}`}
                                    alt={p.Nombre}
                                    className={styles.itemImagen}
                                />
                                <span className={styles.NombreItem} title={p.Nombre}>{p.Nombre} </span>
                                <span className={styles.PrecioItem}>
                                    {(p.Precio).toFixed(2)} €
                                </span>
                            </div>
                            <button className={styles.removeBoton} onClick={() => removeItem(p._id)}> 
                                X
                            </button>
                        </li>
                    ))}
                </ul>

                <div className={styles.footer}>
                    <p className={styles.cantidadTotal}>
                        Total: <strong>{cantidadTotal.toFixed(2)} €</strong>
                    </p>

                    <div className={styles.botonesFooter}>
                        { !usuario ? (
                            <Link to="/login" state={{from: '/checkout' }} className={styles.linkSinEstilo}>
                                <button className={styles.tramitarBoton}>
                                    Tramitar pedido
                                </button>
                            </Link>
                        ) : (
                            <Link to="/pago" className={styles.linkSinEstilo}>
                                <button className={styles.tramitarBoton}>
                                    Tramitar pedido
                                </button>
                            </Link>
                        )}

                        <button  className={styles.vaciarBoton} onClick={clearCarrito}>
                            Vaciar carrito
                        </button>
                    </div>
                    
                </div>
                </>
            )}
        </div>
    )
}